import React from "react";
export const BuyersEmailColumnFormatter = (cellContent, row, rowIndex) => {
  return (
    <>
      <span className="text-dark-75 d-block"></span>
      <> {row.userDetails.email} </>
    </>
  );
};
